<template>
  <div>
    <div class="sample-container">
      <div v-if="getSelectedColor !== ''">
        <div :class="{'selected' : getSelectedColor === getSelectedColor }" class="color-container">
          <img class="color-sample" :src="getSampleImg(getSelectedColor)" @error="getDefaultImg($event)" />
          <span class="legend">{{getSelectedColor}}</span>
        </div>
      </div>
      <div class="color-list-preview" v-else>
        <div v-for="(color, index) in colors" :key="index">
          <div :class="{'selected' : color.TCOL === getSelectedColor }" @click="setColor(color.TCOL, color.TMARQ)" class="color-container" v-if="index < 4 && color.TOK5 === 1">
            <img class="color-sample" :src="getSampleImg(color.TCOL)" @error="getDefaultImg($event)" />
            <span class="legend">{{color.TCOL}}</span>
          </div>
          <div v-else-if="index < 4 && color.TOK5 === 0" class="color-container">
             <div class="color-sample" :style="{'background-image':'url('+require('@/common/assets/img/general/non-disponible.png')+')'}"></div>
            <span class="legend">{{color.TCOL}}</span>
          </div>
        </div>
      </div>
      <span class="btn-more-color" @click="open = true">{{$_('more_colors')}}</span>
    </div>
    <!-- Modal de sélection des coloris -->
    <CustomModal 
    :title="$_('choose_my_ribbon_color').toUpperCase()"
    :open="open"
    @close-modal="open=false">
    <template slot="modal_header">
      <div class="color-sentence">
        <small>{{$_('color_sentence')}}</small>
      </div>
      <div class="color-filter-container">
        <ColorFilter />
      </div>
    </template>
    <template slot="modal_content">
      <div class="color-list">
        <transition-group  name="color" tag="div" class="group-color">
          <div class="color-item" v-for="(color, index) in colors" :key="`color-${index}`">
            <div v-if="color.TOK5 === 1" @click="setPreviewColor(color.TCOL, color.TMARQ)" :class="{'selected' : color.TCOL === getSelectedColor}" class="color-container">
              <img class="color-sample" :src="getSampleImg(color.TCOL)" @error="getDefaultImg($event)" />
              <span class="legend">{{color.TCOL}}</span>
            </div>
            <div v-else class="color-container">
              <div class="color-sample" :style="{'background-image':'url('+require('@/common/assets/img/general/non-disponible.png')+')'}"></div>
              <span class="legend">{{color.TCOL}}</span>
            </div>
          </div>
        </transition-group>
      </div>
    </template>
    <template slot="modal_footer">
      <div class="your-choice">
        <span>{{$_('your_choice')}} : </span>
        <img :src="getSampleImg(pre_selected_color)" @error="getDefaultImg($event)" class="selected-color"></img>
      </div>
      <div class="validate-color">
        <button class="btn" @click="setColor(pre_selected_color, pre_selected_marq)">{{$_('i_validate_my_choice')}}</button>
      </div>
    </template>
  </CustomModal>
  <!-- Fin modal de sélection des coloris -->
	</div>
</template>

<script>

import CustomModal from '@/common/components/widget/Modal/CustomModal'
import ColorFilter from '@/modules/produit/components/ColorFilter'

export default {
  name: 'ColorSelect',
  data() {
    return {
      open: false,
      pre_selected_color: '',
      pre_selected_marq: '',
    }
  },
  components: {
    CustomModal,
    ColorFilter
  },
  props: {
    colors: {
      type: Array,
      default: () => []
    },
    resetcolor: {
      type: Boolean,
      default: false
    }
  }, 
  computed: {
    getSelectedColor() {
      return this.$store.getters['produit/get_fcol'];
    }
  },
  methods: {
    getSampleImg(code) {
      return `${process.env.VUE_APP_API_URL}static/produits/${this.$store.getters['produit/get_fmod']}/coloris/${this.$store.getters['produit/get_fmod']}-${code}.jpg`;
    },
    setPreviewColor(code, marq) {
      this.pre_selected_color = code;
      this.pre_selected_marq = marq;
    },
    setColor(code, marq) {
      this.$store.dispatch('produit/SELECT', {key: 'fcol', value: code});
      this.$store.dispatch('produit/SELECT', {key: 'fmarq', value: marq})
      this.$store.dispatch('produit/LAUNCH_CONFIG');
      this.open = false;
    },
    getDefaultImg(event) {
      if(event !== undefined) {
        event.target.src = `${process.env.VUE_APP_API_URL}static/vignettes/non-disponible.jpg`;
      }
    }
  },
  watch: {
    resetcolor(val) {
      if(val) {
        this.setPreviewColor('', '');
        this.setColor('', '');
      }
    }
  }
}
</script>

<style scoped>
.sample-container {
  display: flex;
  flex-wrap: wrap;
}
.group-color{
  display: flex;
  flex-wrap: wrap;
}
.color-sample {
  width: 100px;
  height: 100px;
  cursor: pointer;
  transition: all .3s;
  background-size: cover;
}
.color-container {
  margin: 10px;
  text-align: center;
  position: relative;
}
.color-sample:hover {
  box-shadow: 0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23);
}
.legend {
  padding: 8px;
  color: #808080;
  display: block;
}
.btn-more-color {
  margin-top: 50px;
  color: #808080;
}
.btn-more-color:hover {
  cursor: pointer;
}
small {
  display: block;
  font-family: 'Lato-Regular';
}
.color-sentence, .color-filter-container {
  margin: 10px 0px;
}
.color-list-preview {
  display: flex;
  flex-wrap: wrap;
}
.color-list {
  display: flex;
  flex-wrap: wrap;
}
.color-item {
  transition: all .5s;
}
.color-enter, .color-leave-to {
  opacity: 0;
  transform: translateX(30px);
}
.your-choice {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 25px 0px 0px;
}
.selected-color{
  width: 20px;
  height: 20px;
  margin-left: 15px;
}
.validate-color {
  text-align: center;
  padding-top: 15px;
}
.color-container.selected:after {
  content: '';
  display: block;
  position: absolute;
  top: 0;
  right: 0;
  border: 3px solid #fff;
  background-color: #000;
  width: 10px;
  height: 10px;
}
</style>